// bao migrate skip
import TabPage from "./../factories/tab-page";
import BaseViewModel2 from "./../factories/base-view-model2";
import "./../bindings/bao-tabs";
import "./../factories/translate-dialog";
import BaseSearchPaging2 from "./../factories/search-paging2";
import * as ko from "knockout";
import Bao from "./../services/bao-service";
import TabController from "./../factories/tab-controller";
import BaoDialog from "./../factories/bao-dialog";
import TranslateDialogViewModel from "./../factories/translate-dialog";
class StateViewModel extends BaseSearchPaging2 {
    ShiftbookInfoStateTab: TabPage;
    Color = ko.observable();
    StateColors = ko.observable();
    StateNumber = ko.observable();
    StateText: KnockoutComputed<any> = ko.pureComputed({
        read: () => {
            switch (Bao.Session.Language.LanguageIndex()) {
                case 1:
                    return this.StateText1();
                case 2:
                    return this.StateText2();
                case 3:
                    return this.StateText3();
                case 4:
                    return this.StateText4();
                case 5:
                    return this.StateText5();
            }
        },
        write: (value) => {
            switch (Bao.Session.Language.LanguageIndex()) {
                case 1:
                    this.StateText1(value);
                    break;
                case 2:
                    this.StateText2(value);
                    break;
                case 3:
                    this.StateText3(value);
                    break;
                case 4:
                    this.StateText4(value);
                    break;
                case 5:
                    this.StateText5(value);
                    break;
            }
        }
    });
    StateText1 = ko.observable();
    StateText2 = ko.observable();
    StateText3 = ko.observable();
    StateText4 = ko.observable();
    StateText5 = ko.observable();
    TranslateDialogViewModel: BaseViewModel2;
    constructor(tabPage: TabPage) {
        super(tabPage);
        // hack only necessary until next bao update
        this["PermissionForward"] = "StateForward";
        this["PermissionBackward"] = "StateBackward";
        // hack end
    }
    CompleteCheck() {
        var isComplete: boolean = true;
        if (Bao.Utils.String.IsNullOrEmpty(this.StateText())) {
            isComplete = false;
        }
        if (!isComplete) {
            new BaoDialog(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgFillMandatorFields"), "info");
        }
        return isComplete;
    }
    InitUrl() {
        return "State/Init";
    }
    Translate = function () {
        var translateDialog = new TranslateDialogViewModel(this.StateText1, this.StateText2, this.StateText3, this.StateText4, this.StateText5);
        translateDialog.Open().then(function () {
        });
    };
    init() {
        //after base init, load tabs
        return super.init().then(() => {
            Bao.post("MasterData/State/GetStateColors", JSON.stringify({}), (result) => {
                if (result != null) {
                    this.StateColors(result.Colors);
                }
            });
            //load tabs
            return super.InitTabController().then(() => {
                this.ShiftbookInfoStateTab = new TabPage();
                this.ShiftbookInfoStateTab.IsClosable(false);
                this.ShiftbookInfoStateTab.Url("MasterData/ShiftbookInfoStateTab");
                this.TabController.AddTab(this.ShiftbookInfoStateTab);
            });
        });
    }
    loaded() {
        this.StateText.subscribe(() => {
            switch (Bao.Session.Language.LanguageIndex()) {
                case 1:
                    this.StateText1(this.StateText());
                    break;
                case 2:
                    this.StateText2(this.StateText());
                    break;
                case 3:
                    this.StateText3(this.StateText());
                    break;
                case 4:
                    this.StateText4(this.StateText());
                    break;
                case 5:
                    this.StateText5(this.StateText());
                    break;
            }
        });
        super.loaded();
    }
}
export default StateViewModel;